import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Discipline } from 'app/shared/models/class/offer/offer';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DisciplineService {

  private api_url = environment.apiUrl + '/Discipline';

  constructor(private http: HttpClient) { }

  getDisciplines(): Observable<Discipline[]> {
    return this.http.get<Discipline[]>(`${this.api_url}/All`);
  }

  getDisciplinesByActorKey(actorkey: number): Observable<Discipline[]> {
    let url = `${this.api_url}/Actor/${actorkey}`;
    if (actorkey === 1) {
      url = `${this.api_url}/All`;
    }
    return this.http.get<Discipline[]>(url);
  }

  getDisciplinesByArticleKey(articleKey: number): Observable<Discipline[]> {
    return this.http.get<Discipline[]>(`${this.api_url}/Article/${articleKey}`);
  }

  postDiscipline(discipline: Discipline): Observable<Discipline> {
    return this.http.post<Discipline>(`${this.api_url}`, discipline);
  }

  updateDiscipline(discipline: Discipline): Observable<Discipline> {
    return this.http.put<Discipline>(`${this.api_url}`, discipline);
  }

  deleteDiscipline(key: number) {
    return this.http.delete(`${this.api_url}/${key}`);
  }

}
